/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
// import { Routes, Route, useLocation } from "react-router-dom";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
// import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";
import ImpressumSite from "pages/Impressum";
import DataPrivacySite from "pages/DataPrivacy";
import CookiesSite from "pages/Cookies";
import ContactSite from "pages/Contact";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="pages/HomeSite" />} />
        <Route exact path="/pages/ImpressumSite" element={<ImpressumSite />} key="impressum" />;
        <Route
          exact
          path="/pages/DataPrivacySite"
          element={<DataPrivacySite />}
          key="datenschutz"
        />
        <Route exact path="/pages/CookiesSite" element={<CookiesSite />} key="cookies" />;
        <Route exact path="/pages/ContactSite" element={<ContactSite />} key="contact" />;
        {/* <Route path="localhost:300*" element={<Navigate to="pages/HomeSite" />} /> */}
      </Routes>
    </ThemeProvider>
  );
}
